import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";
import {number} from "joi";

class TeacherBenefitForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      benefitTypes: [],
      entryYears: [],
      staffs: [],
    },
    data: {
      teacher_id: "",
      entry_year_id: "",
      benefit_type_id: "",
      amount: "",
      issue_date: "",
      verified_by_staff_id: "",
      remark: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;

    const {
      popUp: { edit, tid },
    } = this.context;

    await db
        .getAll(`dropdowns/entryYears`)
        .then(({ data: { data } }) => (drp["entryYears"] = data));

    await db
        .getAll(`dropdowns/benefitTypes`)
        .then(({ data: { data } }) => (drp["benefitTypes"] = data));

    await db
        .getAll(`dropdowns/staff`)
        .then(({ data: { data } }) => (drp["staffs"] = data));


    data.teacher_id = tid;

    if (edit) {
      data.teacher_id = edit.teacher_id;
      data.entry_year_id = edit.entry_year_id;
      data.benefit_type_id = edit.benefit_type_id;
      data.amount = edit.amount;
      data.issue_date = edit.issue_date;
      data.verified_by_staff_id = edit.verified_by_staff_id;
      data.remark = edit.remark;
    }

    this.setState({ drp, data });
  };



  schema = {
    teacher_id: Joi.number().required(),
    entry_year_id: Joi.number().required(),
    benefit_type_id: Joi.number().required(),
    amount: Joi.number().required(),
    issue_date: Joi.string().required(),
    verified_by_staff_id: Joi.number().required(),
    remark: Joi.string().max(1024),
  };

  doSubmit = async () => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        ...this.state.data,
      });

      if (popUp?.edit) {
        await db
          .edit(`benefits/teacher/${popUp?.edit?.id}`, __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((err) => {
            togglePopUp({
              form: "toast",
              message: err.toString(),
              type: "warning",
            });
          });
      } else {
        await db
          .save("benefits/teacher", __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((err) => {
            togglePopUp({
              form: "toast",
              message: err.toString(),
              type: "warning",
            });
          });
      }
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        console.log(errors)
        this.setState({ errors });
      }
    }

  };

  render() {
    const { popUp } = this.context;
    const { drp, errors } = this.state;

    console.log(errors);
    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditBenefits : lbl.AddBenefits}</p>
          </div>
          <div className="form-inputs">
            {this.renderInput("teacher_id","", "hidden")}
            <div className="multi-input">
              {this.renderSelect("entry_year_id", "سمستر", drp.entryYears)}
              {this.renderSelect("benefit_type_id", "امتیاز", drp.benefitTypes)}
            </div>
            <div className="multi-input">
              {this.renderInput("amount", "مبلغ", "number")}
              {this.renderInput("issue_date", "تاریخ تایید", "date")}
            </div>
            {this.renderSelect("verified_by_staff_id", "تایید کننده",  drp.staffs)}
            {this.renderInput("remark", "ملاحظه", "textarea")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default TeacherBenefitForm;
